import React from "react"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"
import DynamicStripeWrapper from "./DynamicStripeWrapper"
import { stripeConnectedSelector } from "store/user"

/**
 * Elements provider for guide-initiated payment flows — the booking window, taking a payment,
 * placing a card hold.
 *
 * The charge lands on the signed-in guide's own account, so the account data comes from their
 * profile rather than from an individual experience or booking payload.
 */
const GuideStripeWrapper = ({ children }) => {
  const stripeAccountData = useSelector(stripeConnectedSelector)
  const guideId = useSelector((state) => state.user.guide?.id)

  return (
    <DynamicStripeWrapper stripeAccountData={stripeAccountData} isReady={!!guideId}>
      {children}
    </DynamicStripeWrapper>
  )
}

GuideStripeWrapper.propTypes = {
  children: PropTypes.node.isRequired
}

export default GuideStripeWrapper
